export default __webpack_public_path__ + "static/media/11.04a240c3.png";